// extracted by mini-css-extract-plugin
export default {"Main":"Methodology_Main__rTKV3","Title":"Methodology_Title__tKfex","Button":"Methodology_Button__3kV4J"};